module.exports = __webpack_public_path__ + "files/SPIADI2026 - RÉA INF ADI - AD PED.cfb23039b269d78851df6eb4620a58fa.xlsx";